// @flow
import { all, fork } from "redux-saga/effects";
import setSelectedStepRequestSaga from "./sagas/setSelectedStep";

function* progressSaga() {
  yield all([fork(setSelectedStepRequestSaga)]);
}

export default progressSaga;
